module.exports = __webpack_public_path__ + "img/nighticon.57c718d8.svg";